import { Box } from "@mui/material";
import { styled } from "styled-components";

export const Container = styled.div`
  height: 100%;
  overflow-y: auto;
`;

export const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
`;

export const ContainerInputs = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
  ${({ fullWidth }) =>
    fullWidth &&
    `
    width: 100%;
    > div {
      width: 100%;
    }
  `};
  margin-bottom: 12px;
`;
export const CheckContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

export const ContainerSwitch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;

  .MuiSwitch-root {
    margin: 0 0 0 -13px;
  }
`;
export const Drawer = styled.div`
  width: 100%;
  border: 1px solid #d1dbe3;
  margin-bottom: 26px;
`;
export const Title = styled.label`
  color: #000000;
  font-size: 16px;
  font-weight: 600;
`;

export const ListProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
`;

export const ContainerFormOneLabel = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const ContainerFormOneLabelSwitch = styled(Box)`
  margin-bottom: 12px;
  display: flex;
  margin-top: -10px;
  margin-left: -9px;
`;
export const ContainerLabelSwitch = styled(Box)`
  margin-bottom: 12px;
  display: flex;
  margin-top: 10px;
  margin-left: -9px;
`;
